// auth-image.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, map } from 'rxjs';

@Pipe({
    name: 'authImage',
    standalone: true
})
export class AuthImagePipe implements PipeTransform {
    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

    transform(url: string): Observable<SafeUrl> {
        // Make an HTTP GET request using HttpClient to trigger the Interceptor
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map(blob => {
                // Generate a local DOM URL for the downloaded blob file
                const objectURL = URL.createObjectURL(blob);
                // Sanitize the URL so Angular allows it to bind to [src]
                return this.sanitizer.bypassSecurityTrustUrl(objectURL);
            })
        );
    }
}
